export function setAdReferrerDetails(router, store) {
  let referrerValue = "";
  const referrer = document.referrer.toLowerCase();
  const knownDomains = ["google", "bing"];

  if (referrer.includes("google")) {
    // Google
    referrerValue = "Google";
  } else if (referrer.includes("bing")) {
    // Bing
    referrerValue = "Bing";
  } else {
    const match = referrer.match(/:\/\/(.[^/]+)/);
    const referrerDomain = match ? match[1] : undefined;

    if (referrerDomain && !knownDomains.includes(referrerValue)) {
      // Other than Google or Bing
      const parts = referrerDomain.split(".");
      if (parts.length === 3 && parts[0] === "www") {
        referrerValue = parts.slice(-2)[0];
      } else if (parts.length === 4 && parts[0] === "www") {
        referrerValue = parts.slice(-3)[0];
      } else if (parts.length === 3 && parts[0] !== "www") {
        referrerValue = parts[0];
      } else if (parts.length === 2 && parts[0] !== "www") {
        referrerValue = parts[0];
      }
    } else {
      // No identifiable referral
      referrerValue = undefined;
    }
  }

  const omtID = router.query ? (router.query.OMTID || router.query.omtid) : undefined;
  if (omtID) {
    store.dispatch("setOmtId", omtID);
    store.dispatch("setAdReferrer", referrerValue);
  } else if (referrerValue && referrerValue.toLowerCase() === "google") {
    store.dispatch("setAdReferrer", "Google Organic Traffic");
  } else if (referrerValue && referrerValue.toLowerCase() === "bing") {
    store.dispatch("setAdReferrer", "Bing Organic Traffic");
  } else if (referrerValue) {
    store.dispatch("setAdReferrer", "Referral Traffic");
  } else {
    store.dispatch("setAdReferrer", "Direct Traffic");
  }

  store.dispatch("setFullReferrer", document.referrer);
}
